import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/materiales/getMateriales.php';

export default function getMateriales({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}